import React from 'react'
import { Box, CircularProgress, Modal, styled, Typography, Button, DialogActions } from '@mui/material'
import { BorderButtonPurple, CustomButton } from '../buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'
import lightTheme from '../../styles/theme/lightTheme'
import '../../styles/components/_box.scss'

const ModalContainer = styled(Box)(({ theme }) => ({
  width: 'calc(100% - 50px)',
  height: 612,
  backgroundColor: '#FFFFFF',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: '50px',

  '&:focus-visible': {
    outline: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: 620,
    height: 450,
    padding: '30px 85px',
  },
}))

const IconBox = styled(Box)(({ theme }) => ({
  width: 85,
  height: 85,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '.iconExclam': {
    color: lightTheme.palette.primary.main,
    fontSize: 80,
  },
}))

const DeleteProfilModalDefenatly = ({ open, onClose, onConfirm, loading }) => {
  return (
    <Modal
      open={open}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(51, 51, 51, 0.65)',
        },
      }}
    >
      <ModalContainer>
        <IconBox>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className={'iconExclam'}
          />
        </IconBox>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '20px',
            textAlign: 'center',
          }}
        >
          <Typography variant={'subtitle2'}>
            Êtes-vous sur de vouloir supprimer le profil ?
          </Typography>
          <Typography variant={'body2'}>
            Cette action est irréversible, le profil sera supprimé
            définitivement.
          </Typography>
        </Box>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <Button
                onClick={onClose}
                variant="outlined"
                sx={{
                  borderColor: '#e5e7eb',
                  color: '#6b7280',
                  '&:hover': {
                    backgroundColor: '#f9fafb',
                  },
                }}
              >
                Non
              </Button>
              <Button
                onClick={onConfirm}
                variant="contained"
                sx={{
                  background: 'linear-gradient(90deg, #dc3545 0%, #c82333 100%)',
                  px: 4,
                  '&:hover': {
                    background: 'linear-gradient(90deg, #c82333 0%, #a71e2a 100%)',
                  },
                }}
              >
                Oui, je supprime le profil définitivement
              </Button>
            </>
          )}
        </DialogActions>
      </ModalContainer>
    </Modal>
  )
}

export default DeleteProfilModalDefenatly
